const getFilterIdFromUrl = (): number | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const filterId = urlParams.get("filter");
  return filterId ? parseInt(filterId, 10) : undefined;
};

export default getFilterIdFromUrl;
